import { useState } from "react";
import { Link } from "react-router-dom";

interface ServicesSectionProps {
  onBookNow: () => void;
}

const domesticServices = [
  {
    id: 1,
    title: "Man & Van Rubbish Removal Service",
    desc: "Our most popular service. Load up a van — full, half or quarter — and we'll clear it same day.",
    price: "from £99.99",
    badge: "SAME-DAY",
    badgeStyle: "bg-cl-green text-white",
    icon: "ri-truck-line",
    accentColor: "#6CC412",
    imageBg: "#6CC412",
    imageH: "h-56",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20a%20clean%20white%20removal%20van%20parked%20on%20a%20residential%20suburban%20street%20with%20a%20uniformed%20worker%20loading%20cardboard%20boxes%20and%20black%20bin%20bags%20into%20the%20open%20rear%20doors%20on%20a%20bright%20sunny%20day%2C%20sharp%20focus%2C%20wide%20angle%2C%20natural%20daylight%2C%20no%20text&width=400&height=300&seq=dom-van-v31&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/rubbish-clearance",
  },
  {
    id: 2,
    title: "Sofa Removal",
    desc: "Old sofa, armchair or corner unit — we'll have it out the door and off your hands.",
    price: "from £73.49",
    badge: "SAME-DAY",
    badgeStyle: "bg-cl-green text-white",
    icon: "ri-sofa-line",
    accentColor: "#09245b",
    imageBg: "#e8edf7",
    imageH: "h-36",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20two%20removal%20workers%20carefully%20carrying%20a%20large%20grey%20fabric%20three-seater%20sofa%20out%20through%20the%20front%20door%20of%20a%20modern%20British%20semi-detached%20house%20on%20a%20sunny%20day%2C%20bright%20exterior%20lighting%2C%20sharp%20focus%2C%20wide%20angle%2C%20no%20text&width=400&height=300&seq=dom-sofa-v31&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/sofa-removal",
  },
  {
    id: 3,
    title: "Private Bin Collection",
    desc: "No council? No problem. We'll collect your general waste bins on a schedule that suits you.",
    price: "from £64.99",
    badge: "NEXT-DAY",
    badgeStyle: "bg-amber-400 text-cl-dark",
    icon: "ri-delete-bin-7-line",
    accentColor: "#6CC412",
    imageBg: "#f0fce4",
    imageH: "h-44",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20a%20collection%20of%20grey%20and%20green%20wheelie%20bins%20lined%20up%20neatly%20on%20a%20clean%20residential%20driveway%20outside%20a%20British%20house%20on%20a%20bright%20overcast%20morning%20ready%20for%20collection%2C%20sharp%20focus%2C%20wide%20angle%2C%20natural%20light%2C%20no%20text%20no%20people&width=400&height=300&seq=dom-bins-v31&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/private-bin-collection",
  },
  {
    id: 4,
    title: "Furniture Collection",
    desc: "Wardrobe, bed frame, table, shelves — we take the lot, responsibly recycled wherever possible.",
    price: "from £73.49",
    badge: "NEW",
    badgeStyle: "bg-cl-dark text-white",
    icon: "ri-armchair-line",
    accentColor: "#09245b",
    imageBg: "#e8edf7",
    imageH: "h-32",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20an%20old%20wooden%20wardrobe%20a%20flat-pack%20chest%20of%20drawers%20and%20a%20dining%20table%20stacked%20together%20on%20a%20residential%20driveway%20outside%20a%20British%20home%20ready%20for%20furniture%20collection%2C%20bright%20natural%20daylight%2C%20sharp%20focus%2C%20wide%20angle%2C%20no%20text%20no%20people&width=400&height=300&seq=dom-furn-v31&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/furniture-removal",
  },
  {
    id: 5,
    title: "House Clearance",
    desc: "Full-property clearance, room by room. Perfect for moves, probate or big declutters.",
    price: "Get a quote",
    badge: "POPULAR",
    badgeStyle: "bg-cl-lime text-cl-dark",
    icon: "ri-home-3-line",
    accentColor: "#6CC412",
    imageBg: "#6CC412",
    imageH: "h-48",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20a%20complete%20house%20clearance%20in%20progress%20with%20stacked%20cardboard%20boxes%20black%20bin%20bags%20old%20furniture%20and%20household%20items%20piled%20up%20on%20the%20front%20lawn%20of%20a%20traditional%20British%20red-brick%20terraced%20house%20under%20clear%20blue%20sky%2C%20sharp%20focus%2C%20wide%20angle%2C%20no%20text&width=400&height=300&seq=dom-house-v31&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/house-clearance",
  },
  {
    id: 6,
    title: "Appliance Removal",
    desc: "Fridge, washing machine, dishwasher — safely disconnected, carried out and disposed of.",
    price: "from £71.74",
    badge: "NEW",
    badgeStyle: "bg-cl-dark text-white",
    icon: "ri-fridge-line",
    accentColor: "#09245b",
    imageBg: "#e8edf7",
    imageH: "h-40",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20a%20uniformed%20worker%20carefully%20moving%20a%20large%20white%20fridge-freezer%20on%20a%20sack%20truck%20out%20of%20a%20modern%20kitchen%20towards%20the%20front%20door%20of%20a%20domestic%20house%2C%20bright%20interior%20and%20natural%20light%20from%20doorway%2C%20sharp%20focus%2C%20wide%20angle%2C%20no%20text&width=400&height=300&seq=dom-appl-v31&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/appliance-removal",
  },
];

const commercialServices = [
  {
    id: 1,
    title: "Commercial Waste Clearance",
    desc: "One-off commercial waste runs for offices, warehouses, retail units — any size, any volume.",
    price: "from £149.99",
    badge: "SAME-DAY",
    badgeStyle: "bg-cl-green text-white",
    icon: "ri-building-4-line",
    accentColor: "#6CC412",
    imageBg: "#6CC412",
    imageH: "h-52",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20two%20waste%20removal%20workers%20in%20hi-vis%20vests%20loading%20black%20bin%20bags%20and%20cardboard%20boxes%20from%20a%20warehouse%20loading%20dock%20into%20a%20large%20white%20commercial%20van%20on%20a%20bright%20clear%20day%2C%20sharp%20focus%2C%20clean%20commercial%20photography%2C%20wide%20angle%2C%20no%20text&width=400&height=300&seq=comm-waste-v30&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/commercial-waste-clearance",
  },
  {
    id: 2,
    title: "Office Clearance",
    desc: "Desks, chairs, filing cabinets, IT equipment — we clear offices fast, often overnight.",
    price: "from £199.99",
    badge: "SAME-DAY",
    badgeStyle: "bg-cl-green text-white",
    icon: "ri-computer-line",
    accentColor: "#09245b",
    imageBg: "#09245b",
    imageH: "h-36",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20a%20modern%20open-plan%20office%20being%20cleared%20with%20stacked%20office%20chairs%20desks%20monitors%20and%20filing%20cabinets%20piled%20neatly%20ready%20for%20collection%2C%20bright%20interior%20lighting%2C%20wide%20angle%2C%20sharp%20focus%2C%20no%20text%20no%20people&width=400&height=300&seq=comm-office-v30&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/office-clearance",
  },
  {
    id: 3,
    title: "Site Clearance",
    desc: "Construction debris, rubble, mixed waste — cleared from site before your deadline.",
    price: "from £249.99",
    badge: "NEXT-DAY",
    badgeStyle: "bg-amber-400 text-cl-dark",
    icon: "ri-tools-line",
    accentColor: "#6CC412",
    imageBg: "#f0fce4",
    imageH: "h-44",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20a%20construction%20site%20clearance%20with%20piles%20of%20rubble%20broken%20concrete%20bricks%20and%20mixed%20building%20debris%20being%20cleared%20by%20a%20worker%20in%20a%20hard%20hat%20and%20hi-vis%20vest%2C%20bright%20daylight%2C%20industrial%20setting%2C%20sharp%20focus%2C%20wide%20angle%2C%20no%20text&width=400&height=300&seq=comm-site-v30&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/site-clearance",
  },
  {
    id: 4,
    title: "Retail Clearance",
    desc: "Shop fitting, old stock, display units — cleared quickly so your refit can get started.",
    price: "from £179.99",
    badge: "NEXT-DAY",
    badgeStyle: "bg-amber-400 text-cl-dark",
    icon: "ri-store-2-line",
    accentColor: "#09245b",
    imageBg: "#e8edf7",
    imageH: "h-32",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20an%20empty%20retail%20shop%20unit%20interior%20with%20old%20metal%20display%20shelving%20units%20gondola%20shelves%20and%20shop%20fittings%20stacked%20and%20ready%20for%20removal%2C%20bright%20indoor%20lighting%2C%20wide%20angle%2C%20sharp%20focus%2C%20no%20text%20no%20people&width=400&height=300&seq=comm-retail-v30&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/retail-clearance",
  },
  {
    id: 5,
    title: "Contract Bin Collections",
    desc: "Ongoing scheduled waste collections for businesses that need reliable, regular service.",
    price: "POA",
    badge: "CONTRACT",
    badgeStyle: "bg-cl-dark text-white",
    icon: "ri-calendar-check-line",
    accentColor: "#6CC412",
    imageBg: "#6CC412",
    imageH: "h-48",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20a%20neat%20row%20of%20commercial%20wheelie%20bins%20in%20dark%20grey%20green%20and%20blue%20lined%20up%20outside%20a%20modern%20business%20premises%20on%20a%20clean%20urban%20street%2C%20bright%20natural%20daylight%2C%20sharp%20focus%2C%20wide%20angle%2C%20no%20text%20no%20people&width=400&height=300&seq=comm-bins-v30&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/contract-bin-collections",
  },
  {
    id: 6,
    title: "Bulk Waste Removal",
    desc: "Large-volume clearance jobs — industrial, agricultural or commercial. We bring the right size vehicle.",
    price: "from £299.99",
    badge: "POPULAR",
    badgeStyle: "bg-cl-lime text-cl-dark",
    icon: "ri-stack-line",
    accentColor: "#09245b",
    imageBg: "#09245b",
    imageH: "h-40",
    image: "https://readdy.ai/api/search-image?query=professional%20photograph%20of%20a%20large%20industrial%20skip%20overflowing%20with%20bulk%20commercial%20waste%20mixed%20materials%20timber%20metal%20and%20debris%20at%20a%20busy%20industrial%20site%2C%20bright%20daylight%2C%20wide%20angle%2C%20sharp%20focus%2C%20no%20text%20no%20people&width=400&height=300&seq=comm-bulk-v30&orientation=landscape",
    imageStyle: "cover" as const,
    href: "/bulk-waste-removal",
  },
];

type Service = typeof domesticServices[number];

function ServiceCard({ service }: { service: Service }) {
  return (
    <div className="h-full">
      <Link to={service.href} className="group flex flex-col h-full cursor-pointer">
        <div className="bg-white rounded-3xl overflow-hidden cartoon-card flex flex-col h-full">

          {/* Image / icon area — fixed height for equal cards */}
          <div
            className="relative flex items-center justify-center h-52 overflow-hidden flex-shrink-0 bg-white"
          >
            {/* Badge */}
            <span
              className={`absolute top-4 left-4 text-xs font-black px-3 py-1 rounded-full z-10 ${service.badgeStyle}`}
              style={{ border: "2px solid rgba(0,0,0,0.10)" }}
            >
              {service.badge}
            </span>

            {service.image ? (
              "imageStyle" in service && service.imageStyle === "cover" ? (
                <img
                  src={service.image}
                  alt={service.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              ) : (
                <img
                  src={service.image}
                  alt={service.title}
                  className="h-[82%] w-auto object-contain transition-transform duration-300 group-hover:scale-105 drop-shadow-sm"
                />
              )
            ) : (
              <div
                className="w-20 h-20 rounded-2xl flex items-center justify-center thick-border transition-transform duration-300 group-hover:scale-105"
                style={{ background: service.accentColor, boxShadow: "5px 5px 0 rgba(0,0,0,0.12)" }}
              >
                <i className={`${service.icon} text-white text-4xl`}></i>
              </div>
            )}
          </div>

          {/* Text content */}
          <div className="px-5 pt-4 pb-5 flex flex-col flex-1">
            <div className="flex items-start justify-between gap-2 mb-2">
              <p className="text-cl-dark font-black leading-tight" style={{ fontSize: "1.2rem" }}>{service.title}</p>
              <span
                className="w-8 h-8 flex items-center justify-center rounded-xl flex-shrink-0 transition-all duration-200 group-hover:scale-110 group-hover:-rotate-12 mt-0.5"
                style={{
                  background: service.accentColor,
                  border: "2px solid #09245b",
                  boxShadow: "3px 3px 0 #09245b",
                }}
              >
                <i className="ri-arrow-right-up-line text-white text-sm"></i>
              </span>
            </div>
            <p className="text-cl-dark/55 text-xs leading-relaxed font-semibold mb-3 flex-1">{service.desc}</p>
            <div className="flex items-center gap-2">
              <span className="text-cl-green font-black text-sm">{service.price}</span>
              <span className="text-cl-dark/25 text-xs">· licensed &amp; insured</span>
            </div>
          </div>

        </div>
      </Link>
    </div>
  );
}

export default function ServicesSection({ onBookNow }: ServicesSectionProps) {
  const [tab, setTab] = useState<"domestic" | "commercial">("domestic");
  const activeServices = tab === "domestic" ? domesticServices : commercialServices;

  return (
    <div>
      <section id="services" className="py-20 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">

          {/* Header */}
          <div className="mb-4">
            <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
              <i className="ri-service-line text-cl-dark text-xs"></i>
              <span className="text-cl-dark text-xs font-black uppercase tracking-widest">What We Do</span>
            </div>
            <h2 className="font-black text-cl-dark leading-[1.05] mb-3" style={{ fontSize: "clamp(2.4rem, 4.5vw, 3.8rem)" }}>
              Our core rubbish removal services
            </h2>
            <p className="text-cl-dark/55 text-base max-w-xl leading-relaxed font-semibold mb-3">
              From £99 · No hidden fees. Fully licensed and insured.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 bg-cl-green text-white text-xs font-black px-3 py-1.5 rounded-full">
                <i className="ri-flashlight-line text-xs"></i>
                SAME DAY SLOTS AVAILABLE
              </span>
              <span className="inline-flex items-center gap-1.5 bg-cl-lime border-2 border-cl-dark text-cl-dark text-xs font-black px-3 py-1.5 rounded-full">
                <i className="ri-shield-check-line text-xs"></i>
                Fully Licensed &amp; Insured
              </span>
            </div>
          </div>

          {/* Tab switcher + content container with integrated border */}
          <div className="relative mt-8 mb-12">
            {/* Tab switcher */}
            <div className="flex justify-start mb-4">
              <div
                className="inline-flex bg-white rounded-full p-1 thick-border max-w-full overflow-x-auto"
                style={{ boxShadow: "3px 3px 0 #09245b" }}
              >
                <button
                  onClick={() => setTab("domestic")}
                  className={`px-4 py-2.5 rounded-full text-sm font-black transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    tab === "domestic"
                      ? "bg-cl-dark text-white"
                      : "text-cl-dark/60 hover:text-cl-dark"
                  }`}
                >
                  <i className="ri-home-heart-line mr-2"></i>
                  Domestic
                </button>
                <button
                  onClick={() => setTab("commercial")}
                  className={`px-4 py-2.5 rounded-full text-sm font-black transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    tab === "commercial"
                      ? "bg-cl-dark text-white"
                      : "text-cl-dark/60 hover:text-cl-dark"
                  }`}
                >
                  <i className="ri-building-line mr-2"></i>
                  Commercial
                </button>
              </div>
            </div>

            {/* Equal-height grid with border container */}
            <div className="border-2 border-gray-200 rounded-3xl p-4 sm:p-8 bg-gray-50/30">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {activeServices.map((service) => (
                  <ServiceCard key={service.id} service={service as Service} />
                ))}
              </div>
            </div>
          </div>

          {/* USP bar */}
          <div className="bg-cl-lime rounded-3xl px-5 py-5 lg:px-8 lg:py-6 grid grid-cols-2 lg:grid-cols-4 gap-4 thick-border cartoon-shadow">
            {[
              { icon: "ri-timer-flash-line", text: "Book in under 60 seconds" },
              { icon: "ri-recycle-line", text: ">95% landfill diversion" },
              { icon: "ri-shield-check-line", text: "Fully Licensed & Insured" },
              { icon: "ri-price-tag-3-line", text: "Prices you can trust" },
            ].map((usp) => (
              <div key={usp.text} className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-xl bg-cl-dark border-2 border-cl-dark flex-shrink-0">
                  <i className={`${usp.icon} text-cl-lime text-sm`}></i>
                </span>
                <span className="text-cl-dark font-black text-xs sm:text-sm leading-snug">{usp.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
